import { createContext, Dispatch, SetStateAction } from 'react';
import { IFilter } from '../types/context';
import {
  IBenchmarkType,
  IDateRange,
  IDepartment,
  IOrganisation,
  OptionType,
} from '../types/filters';

export type DisplayType = 'absolute' | 'percentage' | 'grouped';

interface FiltersContextType {
  dateRange: IDateRange;
  displayType: DisplayType;
  setMonthOffset: (newMonthOffset: number) => void;
  setDateRange: (newRange: IDateRange) => void;
  setDisplayType: (displayType: DisplayType) => void;

  benchmarkType: IBenchmarkType;
  setBenchmarkType: (benchmarkType: IBenchmarkType) => void;

  selectedDepartments: Map<number, boolean>;
  toggleDepartmentAndChildren: (department: IDepartment) => void;
  selectOrDeselectAllDepartments: (newList: Map<number, boolean>) => void;

  selectedOrganisations: Map<number, boolean>;
  toggleOrganisations: (organisation: IOrganisation) => void;
  selectedAllOrg: IOrganisation[] | undefined;
  toggleAllOrg: (organisation: IOrganisation[]) => void;
  selectOrDeselectAllOrganisations: (newList: Map<number, boolean>) => void;

  genderFilter: string[];
  setGenderFilter: (genderFilter: string[]) => void;
  ageFilter: string[];
  setAgeFilter: (ageFilter: string[]) => void;
  regionFilter: string[];
  setRegionFilter: (newRegionFilter: string[]) => void;
  regionOptions: OptionType<string>[]; // Add this line
  setRegionOptions: (options: OptionType<string>[]) => void;

  appliedFilters: any;
  getFilters: () => IFilter;
  resetFilter: () => void;
  cancelFilter: () => void;
  cancelDateFilter: () => void;
  saveFilter: () => void;

  selectAllChecked: any;
  setSelectAllChecked: Dispatch<SetStateAction<{ [key: string]: boolean }>>;

  selectedDate: any;
  setSelectedDate: Dispatch<SetStateAction<{ label: string; value: number }>>;
}

export default createContext<FiltersContextType>({} as FiltersContextType);
